import * as types from "../../mutation-types";
import {removeItem, addOrUpdateItem} from "../../helpers";

export default {
    [types.ADD_OR_UPDATE_PROJECT_SERVICE]: (state, item) => addOrUpdateItem(state, item),

    [types.REMOVE_PROJECT_SERVICE]: (state, item) => removeItem(state, item),

    [types.ADD_OR_UPDATE_EDITING_PROJECT_SERVICE]: (state, item) => addOrUpdateItem(state, item, 'id', 'items'),

    [types.REMOVE_EDITING_PROJECT_SERVICE]: (state, item) => removeItem(state, item, 'id', 'items'),

    [types.SET_EDITING_PROJECT_SERVICES]: (state, item) => state.editingItems = item,

    [types.REORDER_EDITING_PROJECT_SERVICES]: (state, {newIndex, oldIndex}) => {
        if (oldIndex !== false) {
            let service = state.editingItems.splice(oldIndex, 1)[0]
            service.position = newIndex
            state.editingItems.splice(newIndex, 0, service)
        } else {
            let service = state.editingItems.pop()
            service.position = newIndex
            state.editingItems.splice(newIndex, 0, service)
        }
    }
}
